import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=2b2c9319&"
import script from "./SearchFilter.vue?vue&type=script&lang=js&"
export * from "./SearchFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports